<template>
    <div class="copybook-result">
        <ul v-for="r in row">
            <li class="svg"
                :style="{background: `url(/static/img/bg${options.types}${options.color}.jpg)`}"
                v-for="n in 12" v-html="getHtml(r - 1, n - 1)"></li>
        </ul>
    </div>
</template>

<script>
    export default {
        data() {
            return {
            }
        },
        props: {
            options: {
                type: Object,
                default: function () {
                    return {
                        types: '',
                        color: '2',
                        typez: 'zi',
                        blank: '0'
                    }
                }
            },
            input: {
                type: String,
                default: ''
            },
            paths: {
                type: Object,
                default: function () {
                    return {}
                }
            }
        },
        computed: {
            row() {
                let row = this.input.length
                if (this.options.typez === 'article') {
                    row = Math.ceil(this.input.length / 12)
                }
                if (this.options.blank === '1') {
                    row *= 2
                }
                return row
            }
        },
        methods: {
            getHtml(row, colunm) {
                // 处理空行
                let isBlank = false
                let row2 // 实际行
                if (this.options.blank === '1') {
                    if (row % 2 === 1) {
                        isBlank = true
                    }
                    row2 = row / 2
                } else {
                    row2 = row
                }
                if (isBlank) {
                    return ''
                }
                // 判断文字
                let text = ''
                let wordIndex = row2 * 12 + colunm // 第几个字
                if (this.options.typez === 'zi' || this.options.typez === 'bs') {
                    text = this.input[row2 % this.input.length]
                } else if (this.options.typez === 'word') {
                    text = this.input[wordIndex % this.input.length]
                } else if (this.options.typez === 'article') {
                    if (wordIndex <= this.input.length) {
                        text = this.input[wordIndex]
                    } else {
                        text = ''
                    }
                }
                // 判断显示 SVG 还是 文字
                if (this.options.typez === 'bs' && (text === '我' || text === '笔')) {
                    return this.getSvgHTML(text, colunm)
                } else {
                    if (colunm === 0 && this.options.typez === 'zi') {
                        return `<div class="bold">${text}</div>`
                    }
                    return text
                }
            },
            getSvgHTML(text, colunm) {
                let path = this.paths[text]
                let num

                if (this.options.typez === 'zi') {
                    num = path.length
                } else if (this.options.typez === 'bs') {
                    if (colunm > 0 && colunm < path.length) {
                        num = colunm
                    } else {
                        num = path.length
                    }
                }

                let html = `<svg width="54" height="54" version="1.1" xmlns="http://www.w3.org/2000/svg">`
                for (let i = 0; i < num; i++) {
                    let style = colunm === 0 ? 'fill:rgb(0,0,0);stroke:rgb(0,0,0);'
                            : 'fill: rgb(184, 184, 184); stroke: rgb(184, 184, 184);'
                    html += `<path d="${path[i]}" style="${style}" stroke-width="1.5"></path>`
                }
                html += '</svg>'
                return html
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../scss/var";

    .copybook-result {
        width: 938px;
        margin: 0 auto;
        padding-left: 2px;
        @include clearfix;
        li {
            float: left;
            width: 80px;
            height: 80px;
            font-family: 'KaiTi', 'KaiTi_GB2312';
            font-size: 58px;
            text-align: center;
            line-height: 80px;
            background: url('/static/img/bg2.jpg');
            margin: 4px 0px 5px -2px;
            color: #b8b8b8;
            .bold {
                color: #000;
            }
            svg {
                margin: 16px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/copybook/index.vue